import styled from "styled-components";
import { P } from "notes";

export default styled(P)`
  font-size: 14px;
  margin-bottom: 20px;
`;
